module.exports = __webpack_public_path__ + "img/2.7ba554e8.jpg";